import { CONFIG } from "../config/config";

export class StoragePoolUtils {
    canRestoreFiles(): boolean {
        return CONFIG.isPointOfTimeRecoveryEnabled;
    }
}

export const storagePoolUtils = new StoragePoolUtils();